import * as ForwardViewletCommand from '../ForwardViewletCommand/ForwardViewletCommand.js'

export const handleInput = ForwardViewletCommand.forwardViewletCommand('handleInput')
export const handleMouseOver = ForwardViewletCommand.forwardViewletCommand('handleMouseOver')
export const handleMouseOut = ForwardViewletCommand.forwardViewletCommand('handleMouseOut')
export const handleClick = ForwardViewletCommand.forwardViewletCommand('handleClick')
export const handleButtonClick = ForwardViewletCommand.forwardViewletCommand('handleButtonClick')
export const handleClickAdd = ForwardViewletCommand.forwardViewletCommand('handleClickAdd')
export const handleClickRestore = ForwardViewletCommand.forwardViewletCommand('handleClickRestore')
export const handleClickOpenFile = ForwardViewletCommand.forwardViewletCommand('handleClickOpenFile')
